import { gql } from '@apollo/client'
import EducationFragment from './Education.fragment'
import ContractEmployeeLevel from './ContractEmployeeLevel.fragment'
import BusinessUnitFragment from './BusinessUnit.fragment'
import employeeSkillStatusFragment from '../../skill-status/employeeSkillStatus.fragment'
// This is the same for public and resigned public profiles
export default gql`
  fragment PublicProfile on PublicProfile {
    employeeId
    employmentStatus
    legalFirstName
    legalLastName
    email
    username
    chosenLastName
    chosenFirstName
    dateOfBirth
    avatarUrl
    academicTitle
    replyEntryDate
    editable
    skillCenterUrl
    country
    employeeTimezone
    branchOfficeCode
    education {
      ...Education
    }
    currentContractLevel {
      ...ContractEmployeeLevel
    }
    businessUnit {
      ...BusinessUnitAndComapnyName
    }
    skillStatus {
      ...SkillStatusFragment
    }
    activityListEnabled
  }
  ${BusinessUnitFragment}
  ${EducationFragment}
  ${ContractEmployeeLevel}
  ${employeeSkillStatusFragment}
`
